import React from "react";

export default function Testimonials() {
  const testimonials = [
    {
      name: "João Silva",
      role: "Diretor de Marketing",
      company: "Construtora Bahia",
      text: "O trabalho da Aeromaps foi fundamental para acompanhar nossa obra. Imagens aéreas de alta qualidade e entregas pontuais.",
      rating: 5
    },
    {
      name: "Maria Santos",
      role: "Proprietária",
      company: "Imóveis Premium",
      text: "Marketing digital excepcional! As fotos aéreas valorizaram nossos imóveis e aumentaram as vendas em 40%.",
      rating: 5
    },
    {
      name: "Pedro Costa",
      role: "Gerente de Turismo",
      company: "Bahia Tours",
      text: "Profissionalismo e criatividade nas filmagens dos pontos turísticos. Nossos clientes adoraram o conteúdo!",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="relative py-20 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            O Que Dizem Nossos Clientes
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-white mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-blue-500/20 shadow-2xl hover:scale-105 hover:border-blue-500/50 transition-all duration-300 group"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400 group-hover:scale-110 transition-transform"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-300 text-lg italic mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="border-t border-gray-700 pt-4">
                <p className="text-white font-bold text-lg group-hover:text-blue-400 transition-colors">
                  {testimonial.name}
                </p>
                <p className="text-blue-400 text-sm">{testimonial.role}</p>
                <p className="text-gray-400 text-sm">{testimonial.company}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
